import { Component, OnInit } from '@angular/core';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';

@Component({
  selector: 'app-summary-dialog',
  templateUrl: './summary-dialog.component.html',
  styleUrls: ['./summary-dialog.component.scss']
})
export class SummaryDialogComponent implements OnInit {
  constructor(public rwdService: RWDService) {}

  ngOnInit(): void {}
}
